import axios from 'components/Axios';
import {
  Business,
  businessPageImage,
  BusinessUpdateDelete,
  businessUpdatelist,
} from 'redux/APIEndPoint';

const AddBusinessPlace = (payload, url, method) => {
  const promise = axios[method](`${url}`, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const GetBuinessPlaceApi = (url) => {
  const promise = axios.get(url);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const GetBuinessPlaceByNameApi = (url) => {
  const promise = axios.get(url);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const GetBuinessPlaceBySearchpi = (url) => {
  const promise = axios.get(url);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const GetBuinessImages = (id) => {
  const promise = axios.get(`${businessPageImage}/${id}`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const GetBusinessUpdateList = (id) => {
  const promise = axios.get(`${businessUpdatelist}/${id}?clientOffSet=${new Date().getTimezoneOffset()}`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const DeleteBusinessUpdates = (id, attachment) => {
  const promise = axios.delete(`${BusinessUpdateDelete}`, {
    data: {
      id,
      attachment,
    },
  });
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const DeleteBusiness = (id) => {
  const promise = axios.delete(`${Business}${id}`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

export {
  AddBusinessPlace,
  GetBuinessPlaceApi,
  GetBuinessPlaceByNameApi,
  GetBuinessPlaceBySearchpi,
  GetBuinessImages,
  DeleteBusiness,
  DeleteBusinessUpdates,
  GetBusinessUpdateList,
};
